/*
 * @Author: 朱占伟
 * @LastEditors: 邱扬
 * @description: 表单相关校验
 * @Date: 2021-09-16 10:00:27
 * @LastEditTime: 2021-09-18 13:51:34
 */

import {INT} from "src/config/re.config.js"

/**
 * @Date: 2021-09-16 10:01:48
 * @LastEditTime: 
 * @description: 校验值是否为正整数
 * @param {*}
 * @return {*}
 */
export const checkInt = (value)=>{
  if(!value) return ''
  if(!INT.test(value)){
    return  ''
  }
  value = parseInt(value)
  return value
}

/**
 * @Date: 2021-09-16 11:28:40
 * @LastEditTime: 
 * @description: 检查输入金额的合法性
 * @param {*}
 * @return {*}
 */
export const checkMoney = (value)=>{
  if(!value) return ''
  if(typeof value !=='string'){
    value = value.toString()
  }
  if(value && value.includes('.')){
    //输入小数点 但小数点后无数字
    let tem = value.split('.')
    if(!tem[1].length){
      value = tem[0]
      if(value <=0){
        value = ''
      }
    }
    //超过两位小数,只保留小数点后两位
    value = value.slice(0, value.indexOf('.') + 3);
  }else{
    //去除首位0以及非数字
    value = value.replace(/\D|^0/g, '')
  }
  return value
}